export const ERROR_KEYS = ['invalid', 'unavailable', 'unknown'] as const;
export const SUPPORTED_LOCALES = ['en', 'fr', 'es'] as const;
export const PLATFORM_REDIRECT_DELAY_MS = 500;
export const SUBDOMAIN_PATTERN = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/i;
export const KNOWN_PLATFORMS_STORAGE_KEY = 'logalto.known-platforms';
export const LOCALE_STORAGE_KEY = 'logalto.locale';
export const DEFAULT_PLATFORM_COLOR = '#28aebb';
export const OAUTH_AUTHORIZE_PATH = '/oauth/authorize';
export const OAUTH_CLIENT_ID_MAX_LENGTH = 255;
export const OAUTH_PARAMETER_MAX_LENGTH = 2048;
export const OAUTH_LOGIN_HINT_MAX_LENGTH = 320;
export const LOGALTO_WEBSITE_URL = 'https://logalto.com';
export const LOGALTO_SIGNUP_URL = 'https://subscribe.logalto.com/';
export const LOCAL_API_BASE_URL = 'http://localhost:8011';
export const PLATFORM_VALIDATION_PATH = '/api/platforms/validate';
export const PLATFORM_HOSTS_PATH = '/api/platforms/hosts';
